import gql from "graphql-tag"

export const getUserDataSource = gql`
  query getUserDataSourceQuery {
    credimi_futuro_dossiers_view {
      application_source
      company {
        profiles {
          contact {
            sfid
          }
        }
      }
    }
  }
`
